import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as Highcharts from 'highcharts';

export interface PeriodicElement {
  dt: string;
  du: number;
  dc: number;
  fb: number;
  air: number;
  vir: number;
  c: number;
  va: number;
  fl: number;
}


var ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-resultado-pop-up',
  templateUrl: './resultado-pop-up.component.html',
  styleUrls: ['./resultado-pop-up.component.scss']
})
export class ResultadoPopUpComponent implements OnInit {

	highcharts = Highcharts;
  public valueTipoTaxa: String;
  public segmentosInformadosRendaFixa = [];
  public valoresSegmentosRendaFixa = [];

  // Variaveis para Calculadora do Cidadão

  public cidadaoIndex1 = undefined;
  public cidadaoValue1 = undefined;
  public cidadaoType2 = undefined;  
  public cidadaoIndex2 = undefined;
  public cidadaoValue2 = undefined;
  public cidadaoType3 = undefined;  
  public cidadaoIndex3 = undefined;
  public cidadaoValue3 = undefined;
  public cidadaoType4 = undefined;  
  public cidadaoIndex4 = undefined;
  public cidadaoValue4 = undefined;
  public cidadaoChoice = undefined;
  public cidadaoResultado = undefined;

  // Variaveis para Calculadora do Tesouro

  displayedColumns: string[] = ['dt', 'du', 'dc', 'fb', 'air', 'vir', 'c', 'va', 'fl'];
  dataSource = ELEMENT_DATA;
  public poupVsTesouroArray = [];
  public isDarkMode: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ResultadoPopUpComponent>
  ) {
    if(this.data){
      if(this.data['darkMode']) this.isDarkMode = this.data['darkMode'];
      switch(this.data['type']){
        case 'conversao':
          switch(this.data['initial_info']['periodicidade']){
            case 'dia':
              this.valueTipoTaxa = "a.d.%";
              break;
            case 'mes':
              this.valueTipoTaxa = "a.m.%";
              break;
            case 'ano':
              this.valueTipoTaxa = "a.a.%";
              break;
            case 'peri':
              this.valueTipoTaxa = "a.p.%";
              break;
            default:
              console.error("Erro")
          }
          break;
        case 'equiv':
          break;
        case 'rendafixa':
          if(data['result']){
            if(this.isDarkMode){
              this.chartOptions.chart.backgroundColor = '#121212';
              this.chartOptions.xAxis.labels.style.color = 'white';
            }
            for(let i = 0; i < data['result']['titulos'].length; i++){
              !data['result']['titulos'][i]['nom'] ? this.segmentosInformadosRendaFixa.push(data['result']['titulos'][i]['titulo']) : this.segmentosInformadosRendaFixa.push(data['result']['titulos'][i]['nom']);
              !data['result']['titulos'][i]['vl'] ? this.valoresSegmentosRendaFixa.push(data['result']['titulos'][i]['prla']) : this.valoresSegmentosRendaFixa.push(data['result']['titulos'][i]['vl']);
            }
          }
          break;
        case 'cidadao':
          if(data && data['initial_info']){
            switch(data['initial_info']['code']){
              case 0: // Valor do Financiamento
                this.cidadaoIndex1 = "Valor da Prestação";                
                this.cidadaoValue1 = data['initial_info']['aporte'];
                this.cidadaoIndex2 = "Juros a.m.";                
                this.cidadaoValue2 = data['initial_info']['juros'];
                this.cidadaoIndex3 = "Tempo";                
                this.cidadaoValue3 = data['initial_info']['meses'];
                this.cidadaoIndex4 = undefined;                
                this.cidadaoValue4 = undefined;
                this.cidadaoResultado = 'dinheiro';
                this.cidadaoType2 = "juro";
                this.cidadaoType3 = "tempo";
                this.cidadaoType4 = undefined;
                this.cidadaoChoice = "Valor do Financiamento";
                break;
              case 1: // Valor da Prestação
                this.cidadaoIndex1 = "Valor do Financiamento";
                this.cidadaoValue1 = data['initial_info']['fv'];
                this.cidadaoIndex2 = "Juros a.m.";
                this.cidadaoValue2 = data['initial_info']['juros'];
                this.cidadaoIndex3 = "Tempo";
                this.cidadaoValue3 = data['initial_info']['meses'];
                this.cidadaoIndex4 = undefined;
                this.cidadaoValue4 = undefined;
                this.cidadaoType2 = "juro";
                this.cidadaoType3 = "tempo";
                this.cidadaoType4 = undefined;
                this.cidadaoResultado = 'dinheiro';
                this.cidadaoChoice = "Valor da Prestação";
                break;
              case 2: // Juros a.m.
                this.cidadaoIndex1 = "Valor da Prestação";
                this.cidadaoValue1 = data['initial_info']['aporte'];
                this.cidadaoIndex2 = "Valor do Financiamento";
                this.cidadaoValue2 = data['initial_info']['fv'];
                this.cidadaoIndex3 = "Tempo";
                this.cidadaoValue3 = data['initial_info']['meses'];
                this.cidadaoIndex4 = undefined;
                this.cidadaoValue4 = undefined;
                this.cidadaoResultado = 'juro';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "tempo";
                this.cidadaoType4 = undefined;
                this.cidadaoChoice = "Juros a.m.";
                break;
              case 3: // Tempo
                this.cidadaoIndex1 = "Valor da Prestação";
                this.cidadaoValue1 = data['initial_info']['aporte'];
                this.cidadaoIndex2 = "Valor do Financiamento";
                this.cidadaoValue2 = data['initial_info']['fv'];
                this.cidadaoIndex3 = "Juros a.m.";
                this.cidadaoValue3 = data['initial_info']['juros'];
                this.cidadaoIndex4 = undefined;
                this.cidadaoValue4 = undefined;
                this.cidadaoResultado = 'tempo';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "juro";
                this.cidadaoType4 = undefined;
                this.cidadaoChoice = "Tempo";
                break;
              case 4: // Valor Futuro
                this.cidadaoIndex1 = "Valor Presente";
                this.cidadaoValue1 = data['initial_info']['pv'];
                this.cidadaoIndex2 = "Valor do Aporte";
                this.cidadaoValue2 = data['initial_info']['aporte'];
                this.cidadaoIndex3 = "Juros";
                this.cidadaoValue3 = data['initial_info']['juros'];
                this.cidadaoIndex4 = "Tempo";
                this.cidadaoValue4 = data['initial_info']['meses'];
                this.cidadaoResultado = 'dinheiro';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "juro";
                this.cidadaoType4 = "tempo";
                this.cidadaoChoice = "Valor Futuro";
                break;
              case 5: // Valor Presente
                this.cidadaoIndex1 = "Valor Futuro";
                this.cidadaoValue1 = data['initial_info']['fv'];
                this.cidadaoIndex2 = "Valor do Aporte";
                this.cidadaoValue2 = data['initial_info']['aporte'];
                this.cidadaoIndex3 = "Juros";
                this.cidadaoValue3 = data['initial_info']['juros'];
                this.cidadaoIndex4 = "Tempo";
                this.cidadaoValue4 = data['initial_info']['meses'];
                this.cidadaoResultado = 'dinheiro';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "juro";
                this.cidadaoType4 = "tempo";
                this.cidadaoChoice = "Valor Presente";
                break;
              case 6: // Valor do Aporte
                this.cidadaoIndex1 = "Valor Futuro";
                this.cidadaoValue1 = data['initial_info']['fv'];
                this.cidadaoIndex2 = "Valor Presente";
                this.cidadaoValue2 = data['initial_info']['pv'];
                this.cidadaoIndex3 = "Juros";
                this.cidadaoValue3 = data['initial_info']['juros'];
                this.cidadaoIndex4 = "Tempo";
                this.cidadaoValue4 = data['initial_info']['meses'];
                this.cidadaoResultado = 'dinheiro';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "juro";
                this.cidadaoType4 = "tempo";
                this.cidadaoChoice = "Valor do Aporte";
                break;
              case 7: // Juros
                this.cidadaoIndex1 = "Valor Futuro";
                this.cidadaoValue1 = data['initial_info']['fv'];
                this.cidadaoIndex2 = "Valor Presente";
                this.cidadaoValue2 = data['initial_info']['pv'];
                this.cidadaoIndex3 = "Valor do Aporte";
                this.cidadaoValue3 = data['initial_info']['aporte'];
                this.cidadaoIndex4 = "Tempo";
                this.cidadaoValue4 = data['initial_info']['meses'];
                this.cidadaoResultado = 'juro';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "dinheiro";
                this.cidadaoType4 = "tempo";
                this.cidadaoChoice = "Juros";
                break;
              case 8: // Tempo
                this.cidadaoIndex1 = "Valor Futuro";
                this.cidadaoValue1 = data['initial_info']['fv'];
                this.cidadaoIndex2 = "Valor Presente";
                this.cidadaoValue2 = data['initial_info']['pv'];
                this.cidadaoIndex3 = "Valor do Aporte";
                this.cidadaoValue3 = data['initial_info']['aporte'];
                this.cidadaoIndex4 = "Juros";
                this.cidadaoValue4 = data['initial_info']['juros'];
                this.cidadaoResultado = 'tempo';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "dinheiro";
                this.cidadaoType4 = "juro";
                this.cidadaoChoice = "Tempo";
                break;
              case 9: // Aplicação Mensal
                this.cidadaoIndex1 = "Valor Inicial Investido";
                this.cidadaoValue1 = data['initial_info']['pv'];
                this.cidadaoIndex2 = "Valor do Aporte";
                this.cidadaoValue2 = data['initial_info']['aporte'];
                this.cidadaoIndex3 = "Juros a.m.";
                this.cidadaoValue3 = data['initial_info']['juros'];
                this.cidadaoIndex4 = "Tempo";
                this.cidadaoValue4 = data['initial_info']['meses'];
                this.cidadaoResultado = 'dinheiro';
                this.cidadaoType2 = "dinheiro";
                this.cidadaoType3 = "juro";
                this.cidadaoType4 = "tempo";
                this.cidadaoChoice = "Aplicação Mensal";
                break;
              default:
                console.error("epaaaaaa")
            }
          }
          break;
        case 'tesouro':
          ELEMENT_DATA = [];
          this.poupVsTesouroArray = [this.data.result.vpp, this.data.result.vtbr];
          this.chartOptions1.series[0]['data'] = this.poupVsTesouroArray;
          if(this.isDarkMode){
            this.chartOptions1.chart.backgroundColor = '#121212';
            this.chartOptions1.xAxis.labels.style.color = 'white';
            this.chartOptions1.plotOptions.series.dataLabels.style.color = 'white';

          }
          if(data.result.cupons){
            for(let i = 0; i < data.result.cupons.length ; i++){
              ELEMENT_DATA[i] = {
                "dc": data.result.cupons[i].dc,
                "du": data.result.cupons[i].du,
                "c": data.result.cupons[i].c,
                "dt": data.result.cupons[i].dt,
                "fb": data.result.cupons[i].fb,
                "fl": data.result.cupons[i].fl,
                "va": data.result.cupons[i].va,
                "vir": data.result.cupons[i].vir,
                "air": data.result.cupons[i].air
              }
            }
            this.dataSource = ELEMENT_DATA;
          }
          break;
      }
    }
  }

  closeDialog(customOption?){
    this.dialogRef.close(customOption);
  }

  ngOnInit() {
  }

  chartOptions = {
		chart: {
      type: "bar",
			style: {
				fontFamily: 'Roboto',
				fontStyle: 'normal',
				fontWeight: '500',
      },
      backgroundColor: 'white'
		},
		title: {
			text: null,
			align: 'left',
			margin: 25,
		},
		credits: {
			enabled: false
    },
    yAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      title: {
        enabled: false
      },
      labels: {
        enabled: false
      }
    }, 
		xAxis: {
      categories: this.segmentosInformadosRendaFixa,
      title: {
        enabled: false
      },
      name: "",
      labels:{style:{color: '#323232'}},
		},
    tooltip: {
      headerFormat: '',
      valuePrefix: "R$ ",
      formatter: function () {
        return 'R$ ' + this.y.toLocaleString('pt-BR');
      }
    },
    plotOptions: {
      series: {
          dataLabels: {
              enabled: true,
              formatter: function () {
                return 'R$ ' + this.point.options.y.toLocaleString('pt-BR');
              }
          }
      }
    },
    series: [{
        data: this.valoresSegmentosRendaFixa,
        showInLegend: false,
        pointWidth: 20,
        name: ""
    }]
  };
  
  chartOptions1 = {
    height: (9 / 16 * 100) + '%',
		chart: {
      type: "column",
			style: {
				fontFamily: 'Roboto',
				fontStyle: 'normal',
				fontWeight: '500',
      },
      backgroundColor: 'white'
    },
    colors: [
      '#FF4081',
      '#2184FF'
    ],
		title: {
			text: null
		},
		credits: {
			enabled: false
		},
    xAxis: {
        categories: ["Poupança", "Tesouro"],
        title: {
          enabled: false
        },
        labels:{style:{color: '#323232'}},
        gridLineWidth: 0,
        minorGridLineWidth: 0,  
        name: ""
    },
    yAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      title: {
        enabled: false
      },
      labels: {
        enabled: false
      }
    },  
    tooltip: {
      headerFormat: '',
      valuePrefix: "R$ ",
      formatter: function () {
        return 'R$ ' + this.y.toLocaleString('pt-BR');
      }
    },
    plotOptions: {
      column: {
        colorByPoint: true
      },
      series: {
          dataLabels: {
              enabled: true,
			        style:{color: '#323232'},
              formatter: function () {
                return 'R$ ' + this.point.options.y.toLocaleString('pt-BR');
              }
          }
      }
    },
    series: [{
        data: [],
        showInLegend: false,
        pointWidth: 70,
        name: ""
    }]
	};
}
